import { gql } from '__generated__';

export default gql(`
  mutation EditResaleSettings($input: EditResaleSettingsInput!) {
    editResaleSettings(input: $input) {
      ...ResaleFormFields
    }
  }
`);
